/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BackgroundContainer, ResponsiveContainer, SectionContainer, SectionHeading } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { css, cx } from "@panda/css";
import { Grid, VStack } from "@panda/jsx";
import type { SystemStyleObject } from "@panda/types";

import { SpeakerCard } from "./SpeakerCard.molecule";
import { SpeakerCardsSectionFragment } from "@cosmos/hygraph-schema";

const gridLayout: SystemStyleObject = {
	width: "full",
	gridTemplateColumns: "repeat(2, 1fr)",
	mdDown: { gridTemplateColumns: "repeat(1, 1fr)!" },
};

export const SpeakerCardsSection = ({ config, speakers }: SpeakerCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(speakers?.length);
	if (!validHeading && !validContent) return null;

	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack gap="eds.dimension.48" className="speaker-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Grid className={cx("speaker-cards", css(gridLayout))} gap="eds.dimension.16">
								{speakers.map((speaker, i) => (
									<SpeakerCard key={`speaker-card-${i}`} {...speaker} />
								))}
							</Grid>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
